/**
 * opora-artifact-save.js — shared save helper (Edge tools + calculators)
 */
(function (w) {
  'use strict';

  var EDGE = w.OporaEdge || {};
  var API_BASE = (EDGE.WORKER_URL || w.OPORA_WORKER_URL || 'https://api.oporasupply.com').replace(/\/$/, '');
  var ARTIFACTS_ENDPOINT = API_BASE + '/api/artifacts';
  var DASHBOARD_FILES_URL = (EDGE.DASHBOARD_CUSTOM_URL || EDGE.DASHBOARD_URL || 'https://dashboard.oporasupply.com').replace(/\/$/, '') + '/?view=workspace&ws=files';

  function unwrapApi(json) {
    if (json && json.ok === true && json.data !== undefined) return json.data;
    return json;
  }

  function artifactIdFrom(json) {
    var row = unwrapApi(json) || json;
    return (row && (row.id || row.artifact_id)) || null;
  }

  async function authHeaders() {
    if (w.OporaAccount && typeof w.OporaAccount.getAuthHeaders === 'function') {
      return Object.assign({ 'Content-Type': 'application/json' }, await w.OporaAccount.getAuthHeaders());
    }
    var token = await getToken();
    return token
      ? { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
      : { 'Content-Type': 'application/json' };
  }

  var PENDING_COOKIE = 'opora_pending_save';
  var POST_SAVE_DEST_COOKIE = 'opora_post_save_dest';

  function setPostSaveDestFiles() {
    try {
      document.cookie = POST_SAVE_DEST_COOKIE + '=files; path=/; domain=.oporasupply.com; max-age=900; SameSite=Lax; Secure';
    } catch (e) {}
  }
  function clearPostSaveDest() {
    try {
      document.cookie = POST_SAVE_DEST_COOKIE + '=; path=/; domain=.oporasupply.com; max-age=0; Secure';
    } catch (e) {}
  }
  function shouldGoToMyFilesAfterSave() {
    try {
      var params = new URLSearchParams(w.location.search);
      if (params.get('opora_finish_save') === '1' || params.get('opora_saved') === '1') return true;
    } catch (e) {}
    try {
      var match = document.cookie.match(/(?:^|;\s*)opora_post_save_dest=([^;]*)/);
      if (match && decodeURIComponent(match[1]) === 'files') return true;
    } catch (e2) {}
    return false;
  }

  function truncatePayload(payload) {
    var md = payload.body_markdown || payload.content || '';
    if (md.length <= 12000) return payload;
    var copy = Object.assign({}, payload);
    copy.body_markdown = md.slice(0, 12000);
    copy.content = copy.body_markdown;
    return copy;
  }

  function setPendingSaveCookie(toolSlug, payload) {
    try {
      var data = { toolSlug: toolSlug, payload: truncatePayload(payload), ts: Date.now() };
      var json = JSON.stringify(data);
      if (json.length > 3800) {
        data.payload = truncatePayload(Object.assign({}, payload, {
          body_markdown: (payload.body_markdown || payload.content || '').slice(0, 800),
          content: (payload.body_markdown || payload.content || '').slice(0, 800)
        }));
        json = JSON.stringify(data);
      }
      document.cookie = PENDING_COOKIE + '=' + encodeURIComponent(json) +
        '; path=/; domain=.oporasupply.com; max-age=900; SameSite=Lax; Secure';
    } catch (e) {}
  }

  function clearPendingSaveCookie() {
    try {
      document.cookie = PENDING_COOKIE + '=; path=/; domain=.oporasupply.com; max-age=0; Secure';
    } catch (e) {}
  }

  function readPendingSaveCookie() {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + PENDING_COOKIE + '=([^;]*)'));
      if (!match) return null;
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) { return null; }
  }

  function signInRedirect() {
    setPostSaveDestFiles();
    if (w.OporaEdge && typeof w.OporaEdge.stashAuthReturn === 'function') {
      w.OporaEdge.stashAuthReturn();
    } else {
      try { sessionStorage.setItem('_opora_auth_return', w.location.href); } catch (e) {}
    }
    var url = (w.OporaEdge && typeof w.OporaEdge.dashboardAuthUrl === 'function')
      ? w.OporaEdge.dashboardAuthUrl('sign-in')
      : 'https://dashboard.oporasupply.com/';
    w.location.href = url;
  }

  /* ── tiny toast ── */
  function toast(msg, type) {
    var t = document.createElement('div');
    t.className = 'opora-save-toast opora-save-toast--' + (type || 'info');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', right: '24px', zIndex: '9999',
      padding: '12px 20px', borderRadius: '10px', fontSize: '14px',
      fontFamily: 'Inter, sans-serif', maxWidth: '340px',
      background: type === 'error' ? '#C0392B' : '#2C9C95',
      color: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,.18)',
      transition: 'opacity .3s', opacity: '1'
    });
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.opacity = '0';
      setTimeout(function () { t.parentNode && t.parentNode.removeChild(t); }, 350);
    }, 3500);
  }

  async function getToken() {
    if (!w.Clerk || !w.Clerk.session) return null;
    try { return await w.Clerk.session.getToken(); } catch (e) { return null; }
  }

  async function postArtifact(body) {
    var headers = await authHeaders();
    if (!headers.Authorization) {
      throw { status: 401, message: 'Not signed in.' };
    }
    var res = await fetch(ARTIFACTS_ENDPOINT, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    });
    var json = {};
    try { json = await res.json(); } catch (_) {}
    if (!res.ok || json.ok === false) {
      var msg = (json.error && json.error.message) || (json.error && json.error.code) || ('Save failed (' + res.status + ')');
      throw { status: res.status || 500, message: msg };
    }
    return json;
  }

  /* Page handles use hyphens; /api/artifacts stores underscore ids (bid_drafter). */
  var TOOL_ID_MAP = {
    'bid-drafter': 'bid_drafter',
    'rfp-decoder': 'rfp_decoder',
    'handbook-drafter': 'handbook_drafter',
    'lost-bid-autopsy': 'lost_bid_autopsy',
    'hire-right': 'hire_right',
    'compliance-agent': 'compliance_check',
    'compliance-check': 'compliance_check',
    'customer-recovery': 'customer_recovery',
    'margin-sentinel': 'margin_sentinel',
    'review-response': 'review_response',
    'walkthrough-voice': 'voice_walkthrough',
    'scope-of-work-generator': 'scope_of_work',
    'ask-opora':       'ask_opora',
    'ask-opora-deep':  'ask_opora',
    'ask-deep':        'ask_opora',
  };
  function normalizeToolId(slug) {
    if (!slug) return '';
    if (TOOL_ID_MAP[slug]) return TOOL_ID_MAP[slug];
    return String(slug).replace(/-/g, '_');
  }

  async function save(toolSlug, payload) {
    var markdown = payload.body_markdown || payload.content || '';
    var toolId = normalizeToolId(toolSlug);
    var body = {
      title:         payload.title         || (toolSlug + ' — ' + new Date().toISOString().slice(0, 10)),
      tool:          toolId,
      tool_slug:     toolId,
      body_markdown: markdown,
      content:       markdown,
      input_payload: payload.input_payload || {},
      metadata: Object.assign({
        source:       'tool_page',
        generated_at: new Date().toISOString()
      }, payload.metadata || {})
    };
    if (w.OporaAccountFile && typeof w.OporaAccountFile.withAccountBody === 'function') {
      body = w.OporaAccountFile.withAccountBody(body);
    }
    var res;
    try {
      res = await postArtifact(body);
    } catch (err) {
      if (err.status === 401) {
        var token = await getToken();
        if (token) res = await postArtifact(body);
        else throw err;
      } else {
        throw err;
      }
    }
    // Announce the save so the Operator pipeline can promote this work (gate-on-save).
    try {
      w.dispatchEvent(new CustomEvent('opora:file-saved', {
        detail: {
          file: {
            id: artifactIdFrom(res),
            tool: toolSlug,
            tool_slug: toolSlug,
            title: body.title,
            body_markdown: markdown,
            created_at: new Date().toISOString()
          }
        }
      }));
    } catch (e) {}
    return res;
  }

  function mountButton(buttonEl, getPayload) {
    if (!buttonEl) return;

    var toolSlug    = (document.querySelector('meta[name="opora:tool-slug"]') || {}).content || '';
    var lastSavedId = null;
    var isSaving    = false;
    var isSegmented = !!(buttonEl.querySelector('[data-save-label]') ||
      buttonEl.classList.contains('calc-d4-capture-btn'));

    function setLabel(text, asHtml) {
      var label = buttonEl.querySelector('[data-save-label]');
      if (label) {
        if (asHtml) label.innerHTML = text;
        else label.textContent = text;
        return;
      }
      if (asHtml) buttonEl.innerHTML = text;
      else buttonEl.textContent = text;
    }

    function syncAuthState() {
      var isSignedIn = !!(w.Clerk && w.Clerk.user);
      if (!isSignedIn) {
        if (isSegmented) {
          setLabel('Save to Library');
          buttonEl.setAttribute('aria-label', 'Sign in to save to library');
          buttonEl.setAttribute('title', 'Free account to keep this run');
          buttonEl.classList.add('opora-save-btn--anon');
        } else {
          buttonEl.innerHTML = '<span aria-hidden="true">🔒</span> Save to library';
          buttonEl.setAttribute('aria-label', 'Sign in to save to library');
          buttonEl.classList.add('opora-save-btn--anon');
        }
      } else {
        setLabel('Save to Library');
        buttonEl.removeAttribute('title');
        buttonEl.classList.remove('opora-save-btn--anon');
      }
    }

    if (w.Clerk) {
      syncAuthState();
    } else {
      document.addEventListener('clerk:loaded', syncAuthState);
      var poll = setInterval(function () {
        if (w.Clerk) { clearInterval(poll); syncAuthState(); }
      }, 300);
      setTimeout(function () { clearInterval(poll); }, 5000);
    }

    buttonEl.addEventListener('click', async function () {
      if (lastSavedId || isSaving) return;

      async function runSave() {
        isSaving = true;
        buttonEl.disabled  = true;
        setLabel('Saving…');

        var payload;
        try {
          payload = typeof getPayload === 'function' ? getPayload() : {};
        } catch (e) {
          payload = {};
        }

        try {
          var result = await save(toolSlug, payload);
          lastSavedId = artifactIdFrom(result) || 'saved';
          var filesUrl = (w.OporaAccountFile && typeof w.OporaAccountFile.dashboardFilesUrl === 'function')
            ? w.OporaAccountFile.dashboardFilesUrl()
            : DASHBOARD_FILES_URL;
          if (isSegmented) {
            setLabel('Saved · <a href="' + filesUrl + '" style="color:inherit;text-decoration:underline;">View</a>', true);
          } else {
            buttonEl.innerHTML =
              '&#x2713; Saved &middot; <a href="' + filesUrl + '" style="color:inherit;text-decoration:underline;">View in My Files</a>';
          }
          buttonEl.disabled = true;
          buttonEl.classList.add('opora-save-btn--saved');
          toast('Saved to your dashboard', 'success');
          if (w.OporaAccountFile && typeof w.OporaAccountFile.setActiveFileId === 'function' && lastSavedId !== 'saved') {
            w.OporaAccountFile.setActiveFileId(lastSavedId);
          }
        } catch (err) {
          setLabel('Save to Library');
          buttonEl.disabled  = false;
          isSaving = false;
          toast((err && err.message) ? err.message : 'Save failed — please try again.', 'error');
        }
      }

      var isSignedIn = !!(w.Clerk && w.Clerk.user);
      if (!isSignedIn) {
        var payload;
        try {
          payload = typeof getPayload === 'function' ? getPayload() : {};
        } catch (e) {
          payload = {};
        }
        try {
          sessionStorage.setItem('opora_pending_save_d4', JSON.stringify({
            toolSlug: toolSlug,
            payload: payload
          }));
          setPendingSaveCookie(toolSlug, payload);
        } catch (e2) {}
        setLabel('Opening sign-in…');
        /* Same as SOW Save: in-place Clerk popup; redirect only if OporaAuth missing */
        if (w.OporaAuth && typeof w.OporaAuth.openModal === 'function') {
          try {
            document.cookie = 'opora_post_save_dest=; path=/; domain=.oporasupply.com; max-age=0; Secure';
          } catch (e3) {}
          w.OporaAuth.openModal({
            intent: 'sign-up',
            inPlace: true,
            title: 'Save this result',
            tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
            onAuthed: function () {
              try {
                sessionStorage.removeItem('opora_pending_save_d4');
                clearPendingSaveCookie();
              } catch (e4) {}
              runSave();
            }
          });
          return;
        }
        signInRedirect();
        return;
      }

      await runSave();
    });
  }

  w.OporaSave = { save: save, mountButton: mountButton };

  function goToMyFiles() {
    clearPostSaveDest();
    var filesUrl = 'https://dashboard.oporasupply.com/?view=workspace&ws=files&artifact_saved=1';
    try {
      if (w.OporaAccountFile && typeof w.OporaAccountFile.dashboardFilesUrl === 'function') {
        var u = new URL(w.OporaAccountFile.dashboardFilesUrl());
        // Prefer the custom dashboard host even if a helper returns a relative/www path.
        if (u.hostname === 'www.oporasupply.com' || u.hostname === 'oporasupply.com' || !u.hostname) {
          u = new URL('https://dashboard.oporasupply.com/?view=workspace&ws=files');
        }
        u.searchParams.set('view', 'workspace');
        u.searchParams.set('ws', 'files');
        u.searchParams.set('artifact_saved', '1');
        filesUrl = u.href;
      }
    } catch (e) {}
    w.location.replace(filesUrl);
  }

  function resumePendingSave() {
    try {
      var pending = null;
      var raw = sessionStorage.getItem('opora_pending_save_d4');
      if (raw) pending = JSON.parse(raw);
      if (!pending || !pending.toolSlug || !pending.payload) {
        pending = readPendingSaveCookie();
      }
      if (!pending || !pending.toolSlug || !pending.payload) return;
      if (!(w.Clerk && w.Clerk.user)) return;
      sessionStorage.removeItem('opora_pending_save_d4');
      clearPendingSaveCookie();
      // Guest→auth→save always ends in My Files (URL param can be stripped by Clerk).
      save(pending.toolSlug, pending.payload).then(function () {
        toast('Saved to your dashboard', 'success');
        setTimeout(goToMyFiles, 400);
      }).catch(function (err) {
        toast((err && err.message) || 'Save failed — please try again.', 'error');
      });
    } catch (e) {}
  }

  function pollResumePendingSave() {
    var hasPending = false;
    try {
      hasPending = !!sessionStorage.getItem('opora_pending_save_d4') || !!readPendingSaveCookie();
    } catch (e) {}
    if (!hasPending) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (w.Clerk && w.Clerk.user) {
        clearInterval(timer);
        resumePendingSave();
        return;
      }
      if (attempts > 60) clearInterval(timer);
    }, 500);
  }

  w.addEventListener('opora:signed-in', function () {
    setTimeout(resumePendingSave, 500);
  });

  function tryResumeWhenAuthed() {
    if (w.Clerk && w.Clerk.user) resumePendingSave();
  }
  document.addEventListener('clerk:loaded', tryResumeWhenAuthed);
  if (w.OporaAuth && typeof w.OporaAuth.ensureClerkReady === 'function') {
    w.OporaAuth.ensureClerkReady().then(tryResumeWhenAuthed).catch(function () {});
  }
  pollResumePendingSave();

  try {
    var savedFlag = new URLSearchParams(w.location.search).get('opora_saved');
    if (savedFlag === '1') toast('Saved to your dashboard — open My Files anytime.', 'success');
  } catch (e) {}

}(window));
